// services/coinTransactionsService.js
import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_API_URL;
const API_URL = `${BACKEND_URL}/coin-transactions`;

export const getCoinBalance = async (userId, token) => {
  try {
    const response = await axios.get(
     `${BACKEND_URL}/coin-transactions/balance/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.coin_balance; 
  } catch (error) {
    console.error("Error fetching coin balance:", error);
    return 0; // return zero if failed
  }
};

export const createCoinTransaction = async (payload) => {
  const response = await axios.post(API_URL, payload);
  return response.data;
};

export const redeemCoins = async (userId, amount, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/redeem`,
      { user_id: userId, amount },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data; 
  } catch (error) {
    console.error("Error redeeming coins:", error);
    throw error;
  }
};

